import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Params } from '@angular/router';
import { APP_CONFIG } from '../app-config.token';
import { AppConfig } from '../app-config';

@Injectable()
export class IndexService {
  private http = inject(HttpClient);
  private config = inject<AppConfig>(APP_CONFIG);

  constructor() { }

  contact(params: Params): Observable<void> {
    return this.http.post<void>(`${this.config.cmsApiURI}/contacts`, params);
  }
}
